import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1951987d")

_pushScopeId("data-v-1951987d")
const _hoisted_1 = { class: "c-text f-bold" }
const _hoisted_2 = { class: "flex-3 t-left df-middle mx-16" }
const _hoisted_3 = { class: "diff c-text mx-4" }
const _hoisted_4 = { class: "flex-1 t-right" }
const _hoisted_5 = { class: "flex-1 t-right ml-16" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RealTimeQuote = _resolveComponent("RealTimeQuote")

  return (_openBlock(), _createBlock(_component_RealTimeQuote, { symbol: _ctx.symbol }, {
    default: _withId(({code, price, buy, spread, margin, mp, isRise}) => [
      _createVNode("div", {
        class: ["df-middle c-success t-center", {'c-danger': !isRise}]
      }, [
        _createVNode("div", _hoisted_1, _toDisplayString(code), 1),
        _createVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(price) + " ", 1),
          _createVNode("span", _hoisted_3, _toDisplayString(spread), 1),
          _createTextVNode(" " + _toDisplayString(buy), 1)
        ]),
        _createVNode("div", _hoisted_4, _toDisplayString(margin), 1),
        _createVNode("div", _hoisted_5, _toDisplayString(mp), 1)
      ], 2)
    ]),
    _: 1
  }, 8, ["symbol"]))
})